import { apolloSpaceStack2X } from "@nexthink/apollo-components/lib/tokens";
import styled from "styled-components";
import { StyledPanelContainer } from "./PanelDefault.style";

export const StyledPanelCustomDashboardsSimpleContent = styled(StyledPanelContainer)({
  overflow: "auto",
  paddingTop: apolloSpaceStack2X,
});
